import React from 'react';
import { ConversionsUtil } from '../../../utils/conversions_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

export default function CardDuration({ durationInMinutes }) {
  if (!durationInMinutes) {
    return null;
  }
  return (
    <span className="xlate-none">
      {StringConstantsMixin.strings.FILTERS.EST} {ConversionsUtil.minutesToFormattedTime(durationInMinutes, 1)}
    </span>
  );
}
